module.exports = __webpack_public_path__ + "static/media/icon_circle_alert.accedb6c.svg";